import BrandNames from './BrandNames';

export default BrandNames;
